import React from "react";

import HomeUI from "../../../ui/homeUI/_index";

const UserRedWorkReport = () => {
  return (
    <>
      <HomeUI />
    </>
  )
}

export default UserRedWorkReport
